module.exports = __webpack_public_path__ + "img/video3.0e24c6e8.jpg";